import { MojeHeader } from "../../components/header/MojeHeader"
import { MojeFooter } from "../../components/MojeFooter"

function Faq({ question, children }) {
  return (
    <div className="mt-6">
      <p className="my-1 font-bold"> {question}</p>
      <p>{children}</p>
    </div>
  )
}

export default function FaqPage() {
  return (
    <div>
      <MojeHeader venueMode showSearch scrollable />
      <div className="max-w-screen-lg mx-auto p-5 pl-8 min-h-screen leading-6 md:text-justify privacy-page">
        <h1 className="text-center text-xl font-bold my-8">
          Najczęściej zadawane pytania
        </h1>

        <h2 className=" font-bold">
          Cześć, w czym możemy pomóc? Tutaj znajdziesz często zadawane pytania.{" "}
        </h2>

        <Faq question=" Dla rodziców, jak założyć konto?">
          Konto na stronie można założyć w ułatwiony sposób korzystając ze
          swojego konta na Facebooku lub rejestrując się poprzez adres email.
          Link do logowania i rejestracji znajduje się w górnym prawym rogu
          strony. Rejestracja i uzupełnienie kilku podstawowych danych trwa do 3
          minut.
        </Faq>
        <Faq question="Dla rodziców, jak zarezerwować miejsce lub usługę?">
          Będąc zarejestrowanym użytkownikiem można wejść w ofertę firmy i tam
          wybrać scenariusz. Po kliknięciu wybierz klient może uzupełnić
          dodatkowe informacje np. liczbę gości i wysłać takie zgłoszenie do
          organizatora. Po potwierdzeniu klient dostanie informacje o płatności.
        </Faq>
        <Faq
          question="
Dla rodziców – czy rezerwacja jest bezpłatne?"
        >
          Tak, konta dla rodziców i dokonywanie rezerwacji jest bezpłatne
        </Faq>
        <Faq question="Dla rodziców – duże przyjęcie, czy ktoś może mi pomóc w organizacji?">
          Tak, świadczymy usługi planowania przyjęć.{" "}
        </Faq>
        <Faq question="Koszt takiej usługi zależy od wielkości przyjęcia i oczekiwań klienta.">
          W celu ustalenia zakresu pomocy proszę o kontakt
          urodziny@mojeurodziny.pl
        </Faq>
        <Faq question="Dla rodziców – jak wybrać najlepszą ofertę?">
          <p>
            Najlepiej w wyszukiwarce zaznaczyć wiele odpowiadających nam
            kategorii.
          </p>
          <p>
            Jeżeli nie jesteś konkretnie nastawiony na np. urodziny na basenie,
            warto poznać ofertę wielu miejsc i zobaczyć aktualnie obowiązujące
            promocje. (czasem nawet 50% zniżki na konkretne terminy)
          </p>
          <p>
            Na wstępnej liście miejsc można zaznaczyć „serduszkiem” wstępnie
            polubione oferty, aby następnie w swoim profilu (mój profil {"->"}{" "}
            ulubione) zobaczyć ich szczegóły.{" "}
          </p>
          Dla standardowych grup i terminów można od razu przystąpić do
          wysyłania prośby o rezerwacje. (przycisk „wybierz” przy scenariuszach)
          system sam dopasuje cenę do ilości osób a firma tylko ją potwierdzi
          lub zaproponuje zmianę.
        </Faq>
        <Faq question="Dla rodziców – jak zapłacić?">
          Gdy firma potwierdzi rezerwację wyśle dane swojego rachunku bankowego.
          Numer konta bankowego jest sprawdzany przez administratorów (musi
          znajdować się na białej liście i być powiązany z firmą). Zachęcamy do
          płatności przelewem. Drugą opcją jest płatność przelewami24, funkcja
          ta jest dostępna tylko w części kont. Umożliwia płatność kartami czy
          kodem Blik.
        </Faq>
        <Faq question="Dla firm – jak dodać swoją ofertę?">
          Na stronie www.MojeUrodziny.pl/dlaFirm można zobaczyć aktualną ofertę
          dla firm i założyć konto. Wystarczy kliknąć zarejestruj i po
          potwierdzeniu adresu email klient może uzupełnić dane firmy i oferty.
        </Faq>
        <Faq question="Dla firm – mam dwie lokalizacje, jak dodać ofertę?">
          Jeżeli obie lokalizacje operują pod tą samą firmą (numerem NIP i
          rachunkiem bankowym) należy założyć jedno konto firmowe i dodać dwie
          oferty. Wypełniając formularz oferty można wpisać adres lokalizacji.
          Jeżeli działalności są niezależne (mają różne numery NIP) należy
          założyć dwa osobne konta firmowe.
        </Faq>
        <Faq question="Dla firm – dodałem ofertę, kiedy będzie widoczna?">
          Wszystkie oferty widoczne w serwisie przechodzą weryfikacje naszego
          administratora. Zazwyczaj jest to czas do 48h (2 dni robocze). W
          czasie specjalnych promocji dla firm, czas ten może ulec wydłużeniu.
          Publikujemy tylko wizytówki, które zawierają wszystkie wymagane
          informacje. Administrator kontaktuje się z firmami, aby dopytać o
          szczegóły oferty i ją uzupełnić. Jakość prezentowanych treści jest dla
          nas kluczowa, w tym też publikacja przykładowych ofert cenowych.
        </Faq>
        <Faq question="Dla firm - Czy dodanie swojej oferty jest płatne?">
          Portal od 2017 roku do końca 2021 był bezpłatny. Od stycznia 2022
          wdrażamy mini opłaty stałe już od 15 zł miesięcznie. To pozwoli dalej
          rozwijać portal i świadczyć coraz bardziej zaawansowane usługi dla
          firm i rodziców. Ceny inny usług wynikają z dodatkowych umów np. sesji
          zdjęciowych.
        </Faq>
        <Faq question="Dla firm – Czy można się dodatkowo wypromować?">
          Przede wszystkim najlepiej firmy promuje dobrze skomponowana i opisana
          oferta. Wysokiej jakości zdjęcia, przedstawiające lokal lub usługi. W
          systemie można zrobić promocję cenową dla klientów, np. przy
          rezerwacjach z dużym wyprzedzeniem, lub w konkretny dzień tygodnia.
          Mamy pakiety dodatkowego promowania, takie jak: wizytówka na stronie
          głównej, informacja w naszych mediach społecznościowych lub
          newsletterze. Świetną formą reklamy jest też wywiad i film
          przedstawiający ofertę. Podstawowe usługi są widoczne w panelu firmy,
          „promocje”, zazwyczaj szykujemy dedykowane pakiety dla firm.
        </Faq>
        <div>Jeżeli masz dodatkowe pytania prosimy o kontakt. </div>
      </div>
      <MojeFooter />
    </div>
  )
}
